import React, { PureComponent } from "react";

type Props = {
  message?: string,
  random?: boolean,
  size: Number
};

export default class Loader extends PureComponent<Props> {
  render() {
    const { message, size } = this.props;
    let style = this.props.style || {};
    if (size) {
      style = {
        ...style,
        width: size,
        height: size
      };
    }
    return (
      <div className="column v-center h-center" style={style}>
        <div className="loader" style={style} />
        {message && <p className="text-fade">{message}</p>}
      </div>
    );
  }
}
